import React from 'react';
import { ContractorActivity, IConnectGetQuery } from '../../types';
import { API, graphqlOperation } from 'aws-amplify';
import Loader from '../../Components/Loader';
import { message } from 'antd';
import ContractorActivityForm from './partials/ActivityForm';
import { CreateContractorActivityInput } from '../../API';
import { createContractorActivity, deleteContractorActivity, updateContractorActivity } from '../../graphql/mutations';
import mixpanel from 'mixpanel-browser';
import withAppState, { IAppStateComponentProps } from '../../state/withAppState';
import moment from 'moment';

type Props = IAppStateComponentProps & {
  close: () => void;
  onSave?: () => void;
  id: string;
  timesheetId: string;
};
type State = {
  activity?: ContractorActivity | null;
  loading: boolean;
};
class ActivityConnectedForm extends React.Component<Props, State> {
  state = {
    activity: null,
    loading: false,
  };
  async componentDidMount(): Promise<void> {
    if (this.props.id && this.props.id !== 'new') {
      // We should load from the API
      try {
        this.setState({
          loading: true,
        });
        const activity = (await API.graphql(
          graphqlOperation(
            `
query GetContractorActivity($id: ID!) {
  getContractorActivity(id: $id) {
    id
    owner
    timesheetId
    description
    assignedBy
    team
    status
    startDate
    endDate
    document
    timesheet{
      id
      submitted
    }
  }
}
`,
            { id: this.props.id },
          ),
        )) as IConnectGetQuery<ContractorActivity, 'getContractorActivity'>;
        if (activity.data && activity.data.getContractorActivity) {
          this.setState({
            activity: activity.data.getContractorActivity,
            loading: false,
          });
          mixpanel.track('View Contractor Activity', {
            activityId: activity.data.getContractorActivity.id,
          });
        }
      } catch (e) {
        message.error('Contractor Activity not found');
        this.props.close();
      }
    } else if (this.props.id === 'new') {
      this.setState({
        loading: false,
        activity: {
          owner: this.props.appState.user.id,
          timesheetId: this.props.timesheetId,
          employeeId: this.props.appState.user.profile?.id,
          employeeName: this.props.appState.user.profile?.name,
          customerId: this.props.appState.user.profile?.customer[0],
          customerName: this.props.appState.user.profile?.customer[1],
        },
      });
    }
  }
  save = async (values: CreateContractorActivityInput & { submitting?: boolean }): Promise<any> => {
    try {
      if (typeof values.submitting !== 'undefined') {
        delete values.submitting;
      }
      let op, opName;
      if (values.id && values.id !== 'new') {
        op = updateContractorActivity;
        opName = 'updateContractorActivity';
      } else {
        op = createContractorActivity;
        opName = 'createContractorActivity';
      }
      const vals = { ...values };
      if (vals.startDate) {
        vals.startDate = moment(vals.startDate).format('YYYY-MM-DD');
      }
      if (vals.endDate) {
        vals.endDate = moment(vals.endDate).format('YYYY-MM-DD');
      }
      const response = await API.graphql(graphqlOperation(op, { input: vals })) as any;
      if (response && response.data && response.data[opName]) {
        message.success('Your activity was saved');
        this.props.close();
        this.setState({
          activity: { ...response.data[opName] },
        });
        if (this.props.onSave) {
          this.props.onSave();
        }
        return response.data[opName];
      }
      message.error('An error occurred while saving');
      console.log(response.errors);
    } catch (e) {}
  };

  deleteActivity = async () => {
    if (this.props.id && this.props.id !== 'new') {
      const response = await API.graphql(graphqlOperation(deleteContractorActivity, { input: { id: this.props.id } }));
      if (this.props.onSave) {
        this.props.onSave();
      }
      this.props.close();
    }
  };

  render(): React.ReactElement {
    if (this.state.loading) {
      return <Loader />;
    }
    if (this.state.activity) {
      return <ContractorActivityForm record={this.state.activity} save={this.save} close={this.props.close} deleteActivity={this.deleteActivity} />;
    }
    return <Loader />;
  }
}

export default withAppState(ActivityConnectedForm);
